import {Component, forwardRef, OnInit} from "@angular/core";
import {FormSelectComponent} from "../select.component";
import {ReloadComponent} from "../../reload/reload.component";
import {Field} from "../../field";


@Component({
	selector: "tig-assignment-select-component",
	template: `
		<div
			class="dynamic-field form-group"
			[class.has-error]="OBJ_select?.invalid">
			<label class="col-lg-3 control-label">{{getLabelName()|translate}}
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span>
			</label>
			<div class="col-lg-8">
				<select #OBJ_select="ngModel"
					[required]="isRequired()"
					class="form-control"
					name="OBJ_field_config.name"
					[(ngModel)]="OBJ_data?.ids[0]">
					<option value="">{{"please_select"|translate}}</option>
					<option *ngFor="let OBJ_option of ARR_options" value="{{OBJ_option?.id}}">
						{{OBJ_option?.title}}
					</option>
				</select>
				<span class="help-block m-b-none" *ngIf="OBJ_select?.invalid">
                  {{'oError.sRequired'|translate}}
                </span>
				<!--<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>-->
			</div>
		</div>
	`,
	// get all components that extend reload component as viewChildren - see https://github.com/angular/angular/issues/8580
	providers: [
		{
			provide: ReloadComponent,
			useExisting: forwardRef(() => AssignmentSelectComponent)
		},
		{
			provide: Field,
			useExisting: forwardRef(() => AssignmentSelectComponent)
		}
	]
})
export class AssignmentSelectComponent extends FormSelectComponent
{} // end class AssignmentSelectComponent
